export default "__VITE_ASSET__BSjDmEYI__"